import React from "react";
import { Link } from "react-router-dom";

const ContactUs = () => {
  return (
    <>
      {/* Banner */}
      <div className="cover-bg-img">
        <div className="dz-bnr-inr-entry">
          <h1>Contact Us</h1>
          <nav aria-label="breadcrumb" className="breadcrumb-row">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
  <Link to="/">Home</Link>
</li>
              <li className="breadcrumb-item">Contact Us</li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Contact Section */}
      <div className="container">
        <div className="tvnl-inner-contact-details">

          {/* LEFT : CONTACT FORM */}
          <div className="tvnl-inner-contact-details__left">
            <div className="tvnl-blog-details__comment-form">
              <h4 className="tvnl-comment-form__title tvnl-inner-contact-details__title">
                Leave a Message
              </h4>

              <form>
                <div className="row g-xl-4 g-3">
                  <div className="col-6 col-lg-5">
                    <input type="text" placeholder="First Name" />
                  </div>

                  <div className="col-6 col-lg-5">
                    <input type="text" placeholder="Last Name" />
                  </div>

                  <div className="col-6 col-lg-5">
                    <input type="email" placeholder="Email Address" />
                  </div>

                  <div className="col-6 col-lg-5">
                    <input type="number" placeholder="Phone Number" />
                  </div>

                  <div className="col-12">
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                </div>

                <button
                  type="submit"
                  className="tvnl-1-banner-btn tvnl-comment-form__btn"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* RIGHT : CONTACT DETAILS */}
          <div className="tvnl-inner-contact-details__info-card">
            <h3 className="tvnl-inner-contact-details__title">Get In Touch</h3>

            <ul>
              <li className="tvnl-single-contact-info">
                <i className="fa-solid fa-hospital"></i>
                <span className="contact-address">
                  <strong>PRAASH HEALTHCARE</strong><br />
                  Medical Director: Dr. Manju Bansal<br />
                  MBBS, MS (Ophthalmology)
                </span>
              </li>

              <li className="tvnl-single-contact-info">
                <i className="fa-solid fa-phone"></i>
                <div className="contact-numbers">
                  <span>
                    <a href="tel:8076363419">8076363419</a>
                  </span>
                  <span>,</span>
                  <span>
                    <a href="mailto:drmanjubansal@tgvl.in">
                      drmanjubansal@tgvl.in
                    </a>
                  </span>
                </div>
              </li>

              <li className="tvnl-single-contact-info">
                <i className="fa-brands fa-whatsapp"></i>
                <div className="contact-numbers">
                  <span className="store-time__title">
                    Appointment Booking (All Disciplines)
                  </span>
                  <span>
                    <a href="tel:+919958536161">+91 99 5853 6161</a>
                  </span>
                </div>
              </li>

              <li className="tvnl-single-contact-info">
                <i className="fa-solid fa-glasses"></i>
                <div className="contact-numbers">
                  <span className="store-time__title">
                    Optical & Medicine (20% Discount)
                  </span>
                  <span>
                    <a href="tel:+919891926161">+91 98 9192 6161</a>
                  </span>
                </div>
              </li>

              <li className="tvnl-single-contact-info">
                <i className="fa-solid fa-truck-medical"></i>
                <div className="contact-numbers">
                  <span className="store-time__title">Emergency</span>
                  <span>
                    <a href="tel:8750911911">8750 911 911</a>
                  </span>
                </div>
              </li>

              <li className="tvnl-single-contact-info">
                <i className="fa-solid fa-briefcase"></i>
                <div className="contact-numbers">
                  <span className="store-time__title">
                    Business, Jobs & Free Medical Camps
                  </span>
                  <span>,</span>
                  <span>Dr. Tarun Bansal (Managing Director)</span>
                  <br />
                  <span>
                    <a href="tel:9891316160">9891316160</a>
                  </span>
                  <span>,</span>
                  <span>
                    <a href="mailto:tarunbansal@tgvl.in">
                      tarunbansal@tgvl.in
                    </a>
                  </span>
                </div>
              </li>
            </ul>
          </div>


        </div>
      </div>

      <section className="pt-lg-5 pt-3">
        <iframe className="w-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56930.626486469875!2d75.78130204193063!3d26.898284891858108!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db70923dd346d%3A0x8c9b4b20e4d657a2!2sCroma%20-%20Raja%20Park!5e0!3m2!1sen!2sin!4v1767075495618!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </section>
    </>
  );
};

export default ContactUs;